/* eslint-disable react/require-default-props */
import { Box, InputGroup, InputLeftElement, Input } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiSearchLine } from 'react-icons/ri';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function PositionSearch({ value, onChange, placeholder }: Props) {
  const { t } = useTranslation('calendar');
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = React.useState<string>(value);

  React.useEffect(() => {
    setSearchQuery(value || '');
  }, [value]);

  function handleOnChange(val: string) {
    onChange(val);
  }

  return (
    <Box p={[5, 4]}>
      <InputGroup position="relative">
        <InputLeftElement pointerEvents="none" p={0} style={{ color: '#CFD8DC', width: '1.8rem' }}>
          <RiSearchLine />
        </InputLeftElement>
        <Input
          data-testid="SearchInputField"
          value={searchQuery}
          ref={inputRef}
          placeholder={placeholder || t('administration:calendar.sidebarPositionSearchPlaceholder')}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            // eslint-disable-next-line
            const value = e.currentTarget.value;

            if (e.key === 'Enter') {
              handleOnChange(value);
              inputRef.current?.blur();
            }

            if (e.key === 'Escape') {
              setSearchQuery('');
              handleOnChange('');
              inputRef.current?.blur();
            }
          }}
          onBlur={(e) => handleOnChange(e.target.value)}
          style={{ paddingLeft: '1.8rem', paddingRight: '0.5rem' }}
        />
        {inputRef.current === document.activeElement && (
          <Box fontSize="11px" color="gray.500" position="absolute" bottom="-16px" right="0.5rem" data-testid="SearchHint">
            Press
            <Box
              position="relative"
              fontSize="9px"
              display="inline-block"
              fontWeight="bold"
              paddingX={1}
              sx={{
                zIndex: 1,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  bg: 'gray.500',
                  opacity: 0.2,
                  top: '0',
                  left: 0,
                  zIndex: -1,
                  borderRadius: 'sm',
                },
              }}
            >
              ⏎
            </Box>
            to search
          </Box>
        )}
      </InputGroup>
    </Box>
  );
}
